import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { Input } from "@vds/inputs";

import useDebounce from "../../../hooks/useDebounce";
import apiClient from "../../../utils/apiClient";
import { getProductType } from "../../../utils/productTypeUtil";
import styles from "./style.module.css";

const defaultPayload = {
  searchByValue: "Apple",
  from: 0,
  size: 2000,
  deviceCategoryList: [
    // getProductType() === "tablets" ? "Tablets" : "Smart Phone"
    "Smart Phone",
  ],
  shoppingPath: "PROSPECT",
  approach: "",
  flow: "prospect",
};

const PROSPECT_API_FETCH_URL = window.mbtGlobal.basePath;

const defaultURL =
  // "https://www.verizon.com/business/shop/devicesvc/mbt/device/skipImei/search";
  `${PROSPECT_API_FETCH_URL}devicesvc/mbt/device/skipImei/search`;

const AsyncSelectInput = ({
  defaultValue = "",
  extraProps = defaultPayload,
  helperText = "",
  label = "",
  onSelect = () => {},
  placeholder = "",
  url = defaultURL,
  flow = '',
}) => {
  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState(defaultValue);
  const [selectedValue, setSelectedValue] = useState(null);
  const [isError, setIsError] = useState(false);
  const { t } = useTranslation(["byod"]);

  const handleChange = (e) => {
      setOptions([]);
      onSelect(null);
      setSelectedValue(null);
      setInputValue(e.target.value);
  };

  useDebounce(() => makeSearchRequest(), 1000, [inputValue]);

  const handleOptSelect = (opt) => {
    setSelectedValue(opt);
    onSelect(opt);
  };

  const makeSearchRequest = async () => {
    try {
      if (inputValue.length <= 1) {
        setOptions([]);
        setSelectedValue(null);
        return;
      }

      const { data } = await apiClient.post(url, {
        ...extraProps,
        searchByValue: inputValue,
      });
      const { modelCarrierInfoList, serviceStatus } = data;
      if (!modelCarrierInfoList?.length) {
        setIsError(true);
      }
      if (modelCarrierInfoList?.length > 0 && isError) {
        setIsError(false);
      }
      if (!serviceStatus.success) {
        return;
      }
      setOptions(modelCarrierInfoList);
    } catch (err) {
    }
  };

  return (
    <div>
      <Input
        error={isError}
        errorText={
          (isError && inputValue?.length)
            ? t("byod.skipImei.noResultSegment1", { ns: "byod" })
            : t("byod.errorMessages.requiredField", { ns: "byod" })
        }
        helperText={helperText}
        helperTextPlacement="bottom"
        label={label}
        onChange={handleChange}
        placeholder={placeholder}
        value={selectedValue ? selectedValue.modelName : inputValue}
      />
      {options.length > 0 && !selectedValue ? (
        <div className={styles.dropdown}>
          <div
            className={`${styles.dropdownContent} custom-scrollbar`}
            style={{ display: options.length > 0 ? "block" : "none" }}
          >
            {options.map((opt) => (
              <p
                key={opt.sku + opt?.modelName}
                className={styles.option}
                onClick={() => handleOptSelect(opt)}
                data-track={flow === 'byod' ? `Add a smartphone | Make or model | ${opt?.modelName}` : ''}
              >
                {opt.modelName}
              </p>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default AsyncSelectInput;
